import type { Category, Subcategory } from "../types";
import { buildDefaultSearchQuery } from "./buildDefaultSearchQuery";

const SEARCH_CTA_BASE_PATH = "/search";

export function resolveExpandedSearchCtaUrl(
  category: Category,
  subcategory: Subcategory,
): string {
  const query = buildDefaultSearchQuery(
    category.key,
    subcategory.subcategoryLabel,
  );
  return `${SEARCH_CTA_BASE_PATH}?${query}`;
}
